import { useRef, useState } from "react";
import UseFetch from "../components/UseFetch";
import ModalAddPartenaire from "./ModalAddPartenaire";
import $ from 'jquery'
import { NavLink } from "react-router-dom";
import ModalEcriture from "./ModalEcriture";
import { decryptData } from "../components/const";
const ConfierArgent = () => {
    const { data: partenaires, isloading } = UseFetch('confier');
    const tableRef = useRef()
    const [selected, setSelected] = useState(null)
    const user = decryptData("USER");
    $(tableRef.current).DataTable()
    return (
        <div className="container">
            {isloading && <div className="loader"></div>}
            <h3>GESTION DES MONTANT CONFIES</h3>
            {user.droit === "Comptable" && <div className="row p-2"><button className="btn btn-primary w-auto ms-auto" data-bs-toggle="modal" data-bs-target="#modalAddpartenaire">Ajouter un partenaire</button></div>}
            {
                (!isloading && partenaires?.length > 0) ? <div className="table-responsive">
                    <table ref={tableRef} className="table table-hover table-bordered nowrap">
                        <thead className="table-dark ">
                            <tr className="align-middle">
                                <th>N°</th>
                                <th>PRENOM ET NOM</th>
                                <th>TELEPHONE</th>
                                <th>ADRESSE</th>
                                <th>GENRE</th>
                                <th>SOLDE</th>
                                <th className="text-end">ACTIONS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                partenaires?.map((par, ind) =>
                                    <tr key={ind} className="align-middle">
                                        <td>{ind + 1}</td>
                                        <td>{par.nom_complet}</td>
                                        <td>{par.telephone}</td>
                                        <td>{par.adresse}</td>
                                        <td>{par.genre}</td>
                                        <td>{par.soldes[0]?.solde?.toLocaleString()} {par.soldes[0]?.devise}</td>
                                        <td className="text-end">
                                            <NavLink to='/confier/detail' state={{ par }} className="btn btn-info m-1 ">Detail</NavLink>
                                            {user.droit == "Comptable" && <button className="btn btn-success m-1 " data-bs-toggle="modal" data-bs-target="#modal-ecriture" onClick={() => setSelected(par)}>Depot/<span className="text-danger fw-bold">Retrait</span> </button>}
                                        </td>

                                    </tr>
                                )
                            }
                        </tbody>
                    </table>


                </div> : <div className="p-2 fs-3 text-danger text-center bg-danger-subtle">Aucune donnee trouvee</div>
            }
            <ModalAddPartenaire />
            <ModalEcriture patenaire={selected} />
        </div>
    );
}

export default ConfierArgent;